import type { ReactNode } from "react";
import {
  ArrowDownRight,
  ArrowUpRight,
  Bell,
  ChevronDown,
  ChevronRight,
  CircleHelp,
  Command,
  Search,
} from "lucide-react";
import logoForLightSurface from "../../../img/light-mode-logo.png";

export function VoxMark({
  compact = false,
  theme = "dark",
}: {
  compact?: boolean;
  theme?: "dark" | "light";
}) {
  return (
    <div className="brand" aria-label="Vox">
      <img
        className={`brand-mark ${theme === "dark" ? "brand-mark--inverse" : ""}`}
        src={logoForLightSurface}
        alt=""
      />
      {!compact && <span>vox</span>}
    </div>
  );
}

export function Change({
  value,
  suffix = "%",
}: {
  value: number;
  suffix?: string;
}) {
  const positive = value > 0;
  return (
    <span className={`change ${positive ? "change--up" : "change--down"}`}>
      {positive ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />}
      {Math.abs(value)}
      {suffix}
    </span>
  );
}

export function Kicker({ children }: { children: ReactNode }) {
  return <div className="kicker">{children}</div>;
}

export function Confidence({ value }: { value: number }) {
  return (
    <span className="confidence" title="Model confidence">
      <span className="confidence__dot" />
      {value}% confidence
    </span>
  );
}

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      <div>
        {eyebrow && <Kicker>{eyebrow}</Kicker>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}

export function DateControl() {
  return (
    <button className="control-button" type="button">
      Last 30 days
      <ChevronDown size={15} />
    </button>
  );
}

export function Topbar({ onOpenSearch }: { onOpenSearch: () => void }) {
  return (
    <div className="topbar">
      <button className="search-trigger" type="button" onClick={onOpenSearch}>
        <Search size={16} />
        <span>Search intelligence</span>
        <kbd>
          <Command size={11} /> K
        </kbd>
      </button>
      <div className="topbar__actions">
        <button className="icon-button" type="button" title="Help">
          <CircleHelp size={18} />
        </button>
        <button
          className="icon-button notification-button"
          type="button"
          title="Notifications"
        >
          <Bell size={18} />
          <span />
        </button>
        <button className="avatar" type="button" title="Account">
          EM
        </button>
      </div>
    </div>
  );
}

export function EmptyLink({ children }: { children: ReactNode }) {
  return (
    <button className="text-link" type="button">
      {children}
      <ChevronRight size={14} />
    </button>
  );
}
